var map = {
	"./code-brackets.svg": 5466,
	"./css.svg": 924,
	"./ejs.svg": 8905,
	"./html.svg": 1004,
	"./javascript.svg": 474,
	"./mongodb.svg": 9143,
	"./node.svg": 891,
	"./react.svg": 1912,
	"./sass.svg": 313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8304;